import { ReactComponent as IconPlusSVG } from "../../../styles/assets/svg/icon_foodPlus.svg";
import { ReactComponent as IconMinusSVG } from "../../../styles/assets/svg/icon_foodMinus.svg";
import { ReactComponent as IconRightArrow } from "../../../styles/assets/svg/icon_RightChevron.svg";
import { ModalDatePicker } from "src/components/molecules/ModalDatePicker";
import { InputText } from "src/components/atoms/Inputs/InputText";
import {
  formatTimeForPayload,
  formatToAmPm,
} from "src/common/hooks/userTimeFormat";
import styled from "styled-components";

export const daysOfWeek = [
  { label: "월", value: "월" },
  { label: "화", value: "화" },
  { label: "수", value: "수" },
  { label: "목", value: "목" },
  { label: "금", value: "금" },
  { label: "토", value: "토" },
  { label: "일", value: "일" },
];

const IconPlus = styled(IconPlusSVG)`
  cursor: pointer;
  path {
    stroke: #f57c00;
  }
`;

const IconMinus = styled(IconMinusSVG)<{ active: boolean }>`
  cursor: pointer;
  path {
    stroke: ${(props) => (props.active ? "#F57C00" : "#E5E5E5")};
  }
`;

interface pillProps {
  medName: string;
  mode: "daily" | "weekly";
  selectedDays: string[];
  eatCount: number;
  timers: string[];
  activeTimerIndex: number | null;
  setMedName: (value: string) => void;
  setMode: (value: "daily" | "weekly") => void;
  setSelectedDays: (value: string[] | ((prev: string[]) => string[])) => void;
  setEatCount: (value: number | ((prev: number) => number)) => void;
  setTimers: (value: string[] | ((prev: string[]) => string[])) => void;
  setActiveTimerIndex: (value: number | null) => void;
}

export const PillInfo = ({
  medName,
  mode,
  selectedDays,
  eatCount,
  timers,
  activeTimerIndex,
  setMedName,
  setMode,
  setSelectedDays,
  setEatCount,
  setTimers,
  setActiveTimerIndex,
}: pillProps) => {
  // 시간 format
  const formatTime = (h: string, m: string, d: string) =>
    `${d} ${String(h).padStart(2, "0")} : ${String(m).padStart(2, "0")}`;

  const toggleDay = (day: string) => {
    setSelectedDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const increment = () => {
    setEatCount((prev) => {
      const newCount = prev + 1;
      setTimers((prevTimers) => [...prevTimers, "08:00:00"]); // 새 타이머 자리 추가
      return newCount;
    });
  };

  const decrement = () => {
    setEatCount((prev) => {
      if (prev > 1) {
        setTimers((prevTimers) => prevTimers.slice(0, -1)); // 마지막 타이머 제거
        return prev - 1;
      }
      return prev;
    });
  };

  return (
    <>
      <p>약물명</p>
      <InputText
        name="medName"
        size="lg"
        width={100}
        placeholder="ex) 고혈압 약"
        value={medName}
        onChange={(e: any) => setMedName(e.target.value)}
      />
      <p>주기</p>
      <div
        style={{
          width: "100%",
          height: "100%",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: 8,
          display: "flex",
        }}
      >
        <div
          onClick={() => setMode("daily")}
          style={{
            flex: "1 1 0",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 8,
            display: "flex",
          }}
        >
          <div
            style={{
              width: 20,
              height: 20,
              position: "relative",
              overflow: "hidden",
              borderRadius: 9999,
              outline:
                mode === "daily"
                  ? "1.50px #F57C00 solid"
                  : "1.5px #E5E5E5 solid",
              outlineOffset: "-1.50px",
            }}
          >
            {mode === "daily" && (
              <div
                style={{
                  width: 12,
                  height: 12,
                  left: 4,
                  top: 4,
                  position: "absolute",
                  background: "#F57C00",
                  borderRadius: 9999,
                }}
              />
            )}
          </div>
          <div
            style={{
              color: "var(--neutral-700, #404040)",
              fontSize: 14,
              fontWeight: "500",
              lineHeight: "20px",
            }}
          >
            매일
          </div>
        </div>
        <div
          onClick={() => setMode("weekly")}
          style={{
            flex: "1 1 0",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 8,
            display: "flex",
          }}
        >
          <div
            style={{
              width: 20,
              height: 20,
              position: "relative",
              overflow: "hidden",
              borderRadius: 9999,
              outline:
                mode === "weekly"
                  ? "1.50px #F57C00 solid"
                  : "1.5px #E5E5E5 solid",
              outlineOffset: "-1.50px",
            }}
          >
            {mode === "weekly" && (
              <div
                style={{
                  width: 12,
                  height: 12,
                  left: 4,
                  top: 4,
                  position: "absolute",
                  background: "#F57C00",
                  borderRadius: 9999,
                }}
              />
            )}
          </div>
          <div
            style={{
              color: "var(--neutral-700, #404040)",
              fontSize: 14,
              fontWeight: "500",
              lineHeight: "20px",
            }}
          >
            요일선택
          </div>
        </div>
      </div>
      {mode === "weekly" && (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            gap: 8,
          }}
        >
          {daysOfWeek.map((wd, idx) => (
            <div
              key={idx}
              onClick={() => toggleDay(wd.value)}
              style={{
                width: "36px",
                height: "36px",
                background: selectedDays.includes(wd.value)
                  ? "#F57C00"
                  : "#f5f5f5",
                color: selectedDays.includes(wd.value) ? "#FAFAFA" : "#404040",
                boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
                overflow: "hidden",
                borderRadius: 8,
                justifyContent: "center",
                alignItems: "center",
                gap: 10,
                display: "flex",
                fontSize: 14,
                fontWeight: "500",
                lineHeight: "20px",
              }}
            >
              {wd.label}
            </div>
          ))}
        </div>
      )}
      <p>하루 복용 횟수</p>
      <div
        style={{
          width: "100%",
          flex: "1 1 0",
          padding: "14px 12px",
          boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
          borderRadius: 8,
          outline: "1px var(--neutral-100, #F5F5F5) solid",
          outlineOffset: "-1px",
          justifyContent: "space-between",
          alignItems: "center",
          display: "flex",
        }}
      >
        <IconMinus
          active={eatCount > 1}
          style={{ cursor: "pointer" }}
          onClick={() => decrement()}
        />
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            color: "var(--neutral-600, #525252)",
            fontSize: 14,
            fontWeight: "500",
            lineHeight: "20px",
          }}
        >
          {eatCount}번
        </div>
        <IconPlus style={{ cursor: "pointer" }} onClick={() => increment()} />
      </div>
      {timers.map((time, idx) => (
        <div
          key={idx}
          style={{
            width: "100%",
            height: 48,
            padding: "0 12px",
            cursor: "pointer",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "var(--neutral-100, #F5F5F5)",
            borderRadius: 8,
          }}
          onClick={() => setActiveTimerIndex(idx)}
        >
          <span style={{ flex: 1, fontSize: 14, color: "#404040 " }}>
            {time !== "" ? (
              formatToAmPm(time)
            ) : (
              <span style={{ color: "#404040" }}>오전 08 : 00</span>
            )}
          </span>
          <IconRightArrow />
        </div>
      ))}
      {/* 모달 */}
      {activeTimerIndex !== null && (
        <ModalDatePicker
          data={formatToAmPm(timers[activeTimerIndex])}
          title="시간"
          onClose={() => setActiveTimerIndex(null)}
          onConfirm={(hour, min, dayNights) => {
            const newTimers = [...timers];
            newTimers[activeTimerIndex] = formatTimeForPayload(
              formatTime(hour, min, dayNights)
            );
            setTimers(newTimers);
            setActiveTimerIndex(null);
          }}
          time={true}
        />
      )}
    </>
  );
};
